import React, {Component} from "react"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FacebookIcon from "../assets/icons/facebook.svg"
import GoogleIcon from "../assets/icons/google.svg"

class SignUp extends Component {
	constructor() {
		super()
		this.state = {}
	}
	render() {
		return (
			<div className="loginMain">
				<Container>
					<Row className="justify-content-md-center">
					  	<Col md="5">
					  		<div style={{ height: "77px" }}></div>

					  		<div className="f60">
					  			<span className="purple bold">Oja</span>
					  			<span className="yellow">.</span>
					  		</div>

					  		<div className="f30 purple f">
					  			Buy and Sell, all in one place.
				  			</div>

				  			<div className="spacer25"></div>

				  			<div className="">
				  				<input className="loginInput" type="text" placeholder="Email or Phone Number" />
				  			</div>

				  			<div className="spacer25"></div>

				  			<div className="">
				  				<input className="loginInput" type="password" placeholder="Password" />
				  			</div>

				  			<div className="spacer25"></div>

				  			<div className="">
				  				<input className="loginInput" type="password" placeholder="Re-type Password" />
				  			</div>

				  			<div className="spacer25"></div>

				  			<div className="acceptTerms">
				  				<input type="checkbox" /> <span className="f18 purple">Forgot password?</span>
				  			</div>

				  			<div className="spacer25"></div>

				  			<div className="">
				  				<button className="loginBtn f20">SignUp</button>
				  			</div>

				  			<div className="spacer40"></div>

				  			<div class="separator purple bold f20">Or</div>

				  			<div className="spacer40"></div>

				  			<a href="/facebook" className="socialBtn">
				  				<div className="socialLogo">
				  					<img src={FacebookIcon} className="facebookIcon" alt="Facebook Icon" />
				  				</div>
				  				<div className="socialText purple">Continue with Facebook</div>
				  			</a>

				  			<div className="spacer25"></div>

				  			<a href="/google" className="socialBtn">
				  				<div className="socialLogo">
				  					<img src={GoogleIcon} className="googleIcon" alt="Google Icon" />
				  				</div>
				  				<div className="socialText purple">Continue with Google</div>
				  			</a>

				  			<div className="spacer25"></div>


				  		</Col>

					  </Row>
				</Container>
			</div>
		)
	}
}

export default SignUp